<template>

    <main class="dash">
        
        <Headbar type="dash" :class="{ full : activeScrolledNav }">
            <a href="" class="btn main txt-blk" :class="{ dslbd : tempHide }" @click.prevent="fixedCta">
                <span class="hvr"></span>
                <span class="ico">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z" fill="black"/>
                    </svg>
                </span>
                <span class="txt" v-if="Global.currentDashboardStep === 1">Add new row</span>
                <span class="txt" v-if="Global.currentDashboardStep === 2">Add new content</span>
                <span class="txt" v-if="Global.currentDashboardStep === 3">New Subscription plan</span>
            </a>
        </Headbar>
        <!-- <Headbar></Headbar> -->

        <div class="scroll-outer" ref="wrapper">
            <div ref="innerscroll" class="inner-scroll">

                <div class="dash-outer">
                    <div class="container">

                        <div class="lft">
                            <DashboardNav :style="{ transform: 'translateY(' + offY + 'px)' }"></DashboardNav>
                            <div class="platform-state-wrapper" ref="platState">
                                <div class="col platform-state" :style="stateStyle">
                                    <div class="platform-state-inner">
                                        <div class="status-msg col">
                                            <p>Change to your platform aren’t live yet.</p>
                                            <p class="ft-bld view txt-main">
                                                <span class="ico">
                                                    <svg width="16" height="11" viewBox="0 0 18 12" fill="none">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18 5.99997L11.5236 0.476379L11.5236 5.00002H0V7.00002H11.5236L11.5236 11.5236L18 5.99997Z" fill="#F5C952"/>
                                                    </svg>
                                                </span>
                                                <span class="txt" @click.prevent="openPreview">View current version</span>
                                            </p>
                                        </div>
                                        <div class="actns">
                                            <div class="btn bck" @click.prevent="rollback">
                                                <span class="txt">Rollback</span>
                                            </div>
                                            <div class="btn main txt-blk" @click.prevent="publish">
                                                <span class="hvr"></span>
                                                <span class="txt">Publish</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="rgt">
                            <transition
                            :name="transitype"
                            @after-enter="onAfterEnter"
                            @css="false">
                                <router-view></router-view>
                            </transition>
                        </div>

                    </div>
                </div>
        
            </div>
        </div>

        <!-- BLURRED POPUPS -->
        <div class="b-overlay" :class="{ active : Global.activeBlurredOverlay }"></div>
        <ContentOverlay v-if="Global.activeContentOverlay"></ContentOverlay>
        <RowOverlay v-if="Global.activeRowOverlay"></RowOverlay>
        <DeleteContentOverlay v-if="Global.activeDelOverlay"></DeleteContentOverlay>
        <DeleteRowOverlay v-if="Global.activeDelRowOverlay"></DeleteRowOverlay>
        <PlanOverlay v-if="Global.activePlanOverlay"></PlanOverlay>

        <!-- HELPER OVERLAY -->
        <div class="h-overlay" :class="{ active : Global.activeHelperOverlay }" @click.prevent="helperBgClick"></div>
        <ContentsHelperOverlay v-if="Global.ContentsHelperOverlayState == 1"></ContentsHelperOverlay>
        <RowsHelperOverlay v-if="Global.RowsHelperOverlayState == 1"></RowsHelperOverlay>

        <!-- RESPONSIVE HIDE -->
        <div class="resp-mess" v-if="Global.windowWidth < 1025">
            <span class="caption ft-xbld txt-grt">Hey there !</span>
            <p>To add and edit your different contents, you really should be on a bigger resolution device.</p>
            <router-link tag="a" to="/" class="btn main lrg">
                <span class="txt">Back to homepage</span>
            </router-link>
        </div>

    </main>

</template>

<script>

    import router from './../router'
    import Global from '../lib/GlobalState'
    import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar'
    import Headbar from '../partials/Headbar'
    import DashboardNav from '../partials/DashboardNav'
    import ContentOverlay from '../components/ContentOverlay'
    import RowOverlay from '../components/RowOverlay'
    import DeleteContentOverlay from '../components/contents/DeleteContentOverlay'
    import DeleteRowOverlay from '../components/homepage/DeleteRowOverlay'
    import PlanOverlay from '../components/PlanOverlay'
    import ContentsHelperOverlay from '../components/ContentsHelperOverlay'
    import RowsHelperOverlay from '../components/RowsHelperOverlay'
    import { EventBus } from '../event-bus.js'

    class DisableScrollPlugin extends ScrollbarPlugin {
        static pluginName = 'disableScroll';
        static defaultOptions = {
            direction: '',
        };
        transformDelta(delta) {
            if (this.options.direction) {
                delta[this.options.direction] = 0;
            }
            return { ...delta };
        }
    }
    Scrollbar.use(DisableScrollPlugin);

    export default {

        name: 'Dashboard',

        components: {
            Headbar,
            DashboardNav,
            ContentOverlay,
            RowOverlay,
            DeleteContentOverlay,
            DeleteRowOverlay,
            PlanOverlay,
            ContentsHelperOverlay,
            RowsHelperOverlay
        },

        data() {
            return {
                Global,
                offY: 0,
                transitype: '',
                activeScrolledNav: false,
                tempHide: false,
                adjustedStatePosVal: 0
            }
        },

        computed: {
            stateStyle() {
                return { top: this.adjustedStatePosVal + 'px', transform: 'translateY(' + this.offY + 'px)' }
            },
        },

        beforeMount () {
            window.addEventListener('resize', this.handleResize)
        },

        mounted() {
            this.init()
        },

        methods: {

            init() {
                this.listenRouterEvents()
                this.Global.currentDashboardStep = this.$route.meta.position
                this.scroll = Scrollbar.init(this.$refs.wrapper, {
                        syncCallbacks: true,
                        plugins: {
                            disableScroll: {
                            direction: 'x',
                            },
                        },
                    }
                );
                this.scroll.track.xAxis.element.remove()
                this.scroll.addListener(({ offset }) => {
                    this.offY = offset.y
                    this.scrollChecker()
                    if(offset.x > 0)
                        this.scroll.scrollLeft = 0
                });
                this.$nextTick(() => { this.handleResize() });
            },

            handleResize(){
                this.publisherInit()
            },

            publisherInit() {
                let el = this.$refs.platState
                let top = el.getBoundingClientRect().top
                let h = el.clientHeight
                let newPos = this.Global.windowHeight - top - h - 80
                this.adjustedStatePosVal = newPos
            },

            listenRouterEvents(){
                router.beforeEach(this.beforeRouteChange)
            },

            beforeRouteChange(to, from, next) {
                this.safetyCheckHelperClose()
                this.Global.currentDashboardStep = to.meta.position
                if (to.meta.position > from.meta.position)
                    this.transitype = 'btt'
                else
                    this.transitype = 'ttp'
                this.tempHide = true
                setTimeout(() => { this.resetScroll() }, 250)
                next()
            },

            onAfterEnter() {
                // this.resetScroll()
            },

            scrollChecker() {
                if (this.Global.windowWidth >= 1440 && this.Global.windowWidth < 1600){
                    if(this.offY > 51 && !this.activeScrolledNav)
                        this.activeScrolledNav = true
                    if(this.offY < 52 && this.activeScrolledNav)
                        this.activeScrolledNav = false
                } else if (this.Global.windowWidth >= 1600){
                    if(this.offY > 62 && !this.activeScrolledNav)
                        this.activeScrolledNav = true
                    if(this.offY < 63 && this.activeScrolledNav)
                        this.activeScrolledNav = false
                } else {
                    if(this.offY > 42 && !this.activeScrolledNav)
                        this.activeScrolledNav = true
                    if(this.offY < 43 && this.activeScrolledNav)
                        this.activeScrolledNav = false
                }
            },

            resetScroll() {
                this.scroll.setPosition(0,0)
                this.tempHide = false
            },

            // OVERLAYS

            openRowOverlay() {
                this.Global.tempClosingOverlay = false
                this.Global.activeBlurredOverlay = true
                this.Global.activeRowOverlay = true
            },

            openContentOverlay() {
                this.Global.tempClosingOverlay = false
                this.Global.activeBlurredOverlay = true
                this.Global.activeContentOverlay = true
            },

            openPlanOverlay() {
                this.Global.tempClosingOverlay = false
                this.Global.activeBlurredOverlay = true
                this.Global.activePlanOverlay = true
            },

            fixedCta() {
                if(Global.currentDashboardStep === 1)
                    this.openRowOverlay()
                if(Global.currentDashboardStep === 2)
                    this.openContentOverlay()
                if(Global.currentDashboardStep === 3)
                    this.openPlanOverlay()
            },

            helperBgClick() {
                if(this.$route.path == '/dashboard/contents'){
                    this.Global.tempHelperClosingOverlay = true
                    setTimeout(() => { this.Global.activeHelperOverlay = false }, 300)
                    setTimeout(() => { this.Global.ContentsHelperOverlayState = 2 }, 700)
                }
                if(this.$route.path == '/dashboard/homepage'){
                    this.Global.tempHelperClosingOverlay = true
                    setTimeout(() => { this.Global.activeHelperOverlay = false }, 300)
                    setTimeout(() => { this.Global.RowsHelperOverlayState = 2 }, 700)
                }
            },

            safetyCheckHelperClose() {
                if(this.$route.path == '/dashboard/contents' && this.Global.ContentsHelperOverlayState == 1){
                    this.Global.tempHelperClosingOverlay = true
                    this.Global.activeHelperOverlay = false
                    this.Global.ContentsHelperOverlayState = 2
                }
                if(this.$route.path == '/dashboard/homepage' && this.Global.RowsHelperOverlayState == 1){
                    this.Global.tempHelperClosingOverlay = true
                    this.Global.activeHelperOverlay = false
                    this.Global.RowsHelperOverlayState = 2
                }
            },

            openPreview() {
                if(!window.preview || window.preview.closed) {
                    window.preview = window.open("/preview", '_blank');
                    window.preview.focus()
                    this.publish()
                } else {
                    window.preview.focus()
                }
            },

            publish() {

                if(!window.preview || window.preview.closed) {
                    window.preview = window.open("/preview", '_blank');
                    window.preview.focus()
                } else {
                    window.preview.focus()
                }

                this.Global.rollbackState.rows = JSON.parse(JSON.stringify(this.Global.rows))
                this.Global.rollbackState.plans = JSON.parse(JSON.stringify(this.Global.plans))
                this.Global.rollbackState.assets = JSON.parse(JSON.stringify(this.Global.assets))
                this.Global.rollbackState.mockupConfig = JSON.parse(JSON.stringify(this.Global.mockupConfig))

                window.preview.onload = () => {
                    window.bc.postMessage({
                        rows: this.Global.rows,
                        plans: this.Global.plans,
                        assets: this.Global.assets,
                        mockupConfig: this.Global.mockupConfig,
                    });
                }

                window.bc.postMessage({
                    rows: this.Global.rows,
                    plans: this.Global.plans,
                    assets: this.Global.assets,
                    mockupConfig: this.Global.mockupConfig,
                });
            },

            rollback() {
                this.Global.rows = JSON.parse(JSON.stringify(this.Global.rollbackState.rows))
                this.Global.plans = JSON.parse(JSON.stringify(this.Global.rollbackState.plans))
                this.Global.assets = JSON.parse(JSON.stringify(this.Global.rollbackState.assets))
                this.Global.mockupConfig = JSON.parse(JSON.stringify(this.Global.rollbackState.mockupConfig))
            }
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize)
        }

    }

</script>